// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/Gilroy-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/Gilroy-ThinItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/Gilroy-UltraLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/fonts/Gilroy-UltraLightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/fonts/Gilroy-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/fonts/Gilroy-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/fonts/Gilroy-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/fonts/Gilroy-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/fonts/Gilroy-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/fonts/Gilroy-MediumItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/fonts/Gilroy-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/public/fonts/Gilroy-SemiBoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/public/fonts/Gilroy-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/public/fonts/Gilroy-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/public/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/public/fonts/Gilroy-ExtraBoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/public/fonts/Gilroy-Heavy.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/public/fonts/Gilroy-HeavyItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/public/fonts/Gilroy-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/public/fonts/Gilroy-BlackItalic.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Gilroy Font Face Declarations */
@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 100;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-weight: 200;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype');
  font-weight: 400;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('opentype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('opentype');
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 600;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('opentype');
  font-weight: 700;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('opentype');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('opentype');
  font-weight: 800;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('opentype');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('opentype');
  font-weight: 900;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('opentype');
  font-weight: 950;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gilroy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('opentype');
  font-weight: 950;
  font-style: italic;
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Gilroy', sans-serif;
}

html, body {
  overscroll-behavior-y: none;
}

body {
  font-family: 'Gilroy', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #EEECF9;
  color: #17202B;
}

/* NYSORA-inspired Light Mode Styles */
.chatgpt-app {
  display: flex;
  height: 100vh;
  background: #EEECF9;
  color: #17202B;
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
}

/* Loading container */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: #EEECF9;
  color: #132775;
  font-size: 1.5rem;
  font-weight: 500;
  flex-direction: column;
  font-family: 'Gilroy', sans-serif;
}

/* Spinner animation */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(19, 39, 117, 0.15);
  border-radius: 50%;
  border-top-color: #132775;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(19, 39, 117, 0.1);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Smaller spinner for inline loading */
.spinner-small {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(19, 39, 117, 0.15);
  border-radius: 50%;
  border-top-color: #132775;
  animation: spin 1s ease-in-out infinite;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}

/* Loading text animation */
.loading-text {
  display: inline-flex;
  align-items: center;
  color: #132775;
  font-weight: 500;
}

.loading-text::after {
  content: '.';
  animation: dots 1.5s steps(5, end) infinite;
  width: 20px;
  text-align: left;
  color: #132775;
}

@keyframes dots {
  0%, 20% {
    content: '.';
  }
  40% {
    content: '..';
  }
  60% {
    content: '...';
  }
  80%, 100% {
    content: '';
  }
}

@media (max-width: 900px) {
  .chatgpt-app {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .chatgpt-app {
    flex-direction: column;
    height: 100dvh;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,+DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAsE;EACtE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gEAAmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mDAAmD;AACrD;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;AACF","sourcesContent":["/* Gilroy Font Face Declarations */\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-Thin.otf') format('opentype');\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-ThinItalic.otf') format('opentype');\n  font-weight: 100;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-UltraLight.otf') format('opentype');\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-UltraLightItalic.otf') format('opentype');\n  font-weight: 200;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-Light.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-LightItalic.otf') format('opentype');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-Regular.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-RegularItalic.otf') format('opentype');\n  font-weight: 400;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-Medium.otf') format('opentype');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-MediumItalic.otf') format('opentype');\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-SemiBold.otf') format('opentype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-SemiBoldItalic.otf') format('opentype');\n  font-weight: 600;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-Bold.otf') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-BoldItalic.otf') format('opentype');\n  font-weight: 700;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-ExtraBold.otf') format('opentype');\n  font-weight: 800;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-ExtraBoldItalic.otf') format('opentype');\n  font-weight: 800;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-Heavy.otf') format('opentype');\n  font-weight: 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-HeavyItalic.otf') format('opentype');\n  font-weight: 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-Black.otf') format('opentype');\n  font-weight: 950;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gilroy';\n  src: url('/public/fonts/Gilroy-BlackItalic.otf') format('opentype');\n  font-weight: 950;\n  font-style: italic;\n  font-display: swap;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Gilroy', sans-serif;\n}\n\nhtml, body {\n  overscroll-behavior-y: none;\n}\n\nbody {\n  font-family: 'Gilroy', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #EEECF9;\n  color: #17202B;\n}\n\n/* NYSORA-inspired Light Mode Styles */\n.chatgpt-app {\n  display: flex;\n  height: 100vh;\n  background: #EEECF9;\n  color: #17202B;\n  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;\n}\n\n/* Loading container */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n  background: #EEECF9;\n  color: #132775;\n  font-size: 1.5rem;\n  font-weight: 500;\n  flex-direction: column;\n  font-family: 'Gilroy', sans-serif;\n}\n\n/* Spinner animation */\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(19, 39, 117, 0.15);\n  border-radius: 50%;\n  border-top-color: #132775;\n  animation: spin 1s ease-in-out infinite;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(19, 39, 117, 0.1);\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Smaller spinner for inline loading */\n.spinner-small {\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(19, 39, 117, 0.15);\n  border-radius: 50%;\n  border-top-color: #132775;\n  animation: spin 1s ease-in-out infinite;\n  display: inline-block;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n/* Loading text animation */\n.loading-text {\n  display: inline-flex;\n  align-items: center;\n  color: #132775;\n  font-weight: 500;\n}\n\n.loading-text::after {\n  content: '.';\n  animation: dots 1.5s steps(5, end) infinite;\n  width: 20px;\n  text-align: left;\n  color: #132775;\n}\n\n@keyframes dots {\n  0%, 20% {\n    content: '.';\n  }\n  40% {\n    content: '..';\n  }\n  60% {\n    content: '...';\n  }\n  80%, 100% {\n    content: '';\n  }\n}\n\n@media (max-width: 900px) {\n  .chatgpt-app {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 600px) {\n  .chatgpt-app {\n    flex-direction: column;\n    height: 100dvh;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
